/**
 * Enumeration representing the various statuses an order can have.
 */
export enum OrderStatus {
    Pending = 1,
    Completed = 2,
    Invoiced = 3,
    ExportedToAccounting = 4,
    CompletedInAccounting = 5,
    Cancelled = 6,
    PaymentAdjusted = 7,
}

export const OrderStatusLabels: Record<OrderStatus, string> = {
    [OrderStatus.Pending]: 'Pending',
    [OrderStatus.Completed]: 'Completed',
    [OrderStatus.Invoiced]: 'Invoiced',
    [OrderStatus.ExportedToAccounting]: 'Exported in Accounting',
    [OrderStatus.CompletedInAccounting]: 'Completed in Accounting',
    [OrderStatus.Cancelled]: 'Canceled',
    [OrderStatus.PaymentAdjusted]: 'Payment Adjusted',
};
